/** @deprecated Alias for `<schmancy-window>`; kept for existing `<schmancy-float>` consumers. */

import { customElement } from 'lit/decorators.js'
import SchmancyWindow from '@schmancy/primitives/window/window'

@customElement('schmancy-float')
export default class SchmancyFloat extends SchmancyWindow {}

declare global {
	interface HTMLElementTagNameMap {
		'schmancy-float': SchmancyFloat
	}
}
